import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorCodeTranslatorService {
  failureCodes1 = [
    { code: 0, description: 'No Error, success' },
    { code: 1, description: 'DNS lookup failed' },
    { code: 2, description: 'TCP connection failed' },
    { code: 3, description: 'Time sync / NTP failure' },
    { code: 4, description: 'Internal communication failure' },
    { code: 5, description: 'Too Many Tests' },
    { code: 6, description: 'Internal Error (System)' },
    { code: 7, description: 'Internal Error (Test)' },
    { code: 8, description: 'Old Ingest Data' },
    { code: 9, description: 'To many redirects' },
    { code: 10, description: 'TCP Connection succeeded, but operation failed' },
    { code: 100, description: 'All Pings failed' },
    { code: 200, description: 'No Hops Responded' },
    { code: 201, description: 'Endpoint did not respond' },
    { code: 3002, description: 'Redirect Failed' },
    { code: 400, description: 'No Response to INVITE' },
    { code: 401, description: 'SIP INVITE rejected' },
    { code: 402, description: 'NO RTP audio received' },
    { code: 403, description: 'SIP Authorization failed' },
    { code: 404, description: 'No Such alias' },
    { code: 405, description: 'Call receiver is busy' },
    { code: 486, description: 'Busy Here' },
    { code: 499, description: 'SIP General error' },
    { code: 500, description: 'Failed to connect to Control Socket' },
    { code: 501, description: 'Not Implemented' },
    { code: 502, description: 'Bad Gateway' },
    { code: 503, description: 'Service Unavailable' },
    { code: 504, description: 'Gateway Timeout' },
    { code: 505, description: 'HTTP Version Not Supported' }
  ];

  failureCodes2 = [
    { code: 200, description: 'OK' },
    { code: 201, description: 'Created' },
    { code: 202, description: 'Accepted' },
    { code: 203, description: 'Non-Authoritative Information' },
    { code: 204, description: 'No Content' },
    { code: 205, description: 'Reset Content' },
    { code: 300, description: 'Multiple Choices' },
    { code: 301, description: 'Moved Permanently' },
    { code: 302, description: 'Found (Previously "Moved temporarily")' },
    { code: 303, description: 'See Other' },
    { code: 304, description: 'Not Modified' },
    { code: 305, description: 'Use Proxy' },
    { code: 400, description: 'Bad Request' },
    { code: 401, description: 'Unauthorized ' },
    { code: 402, description: 'Payment Required' },
    { code: 403, description: 'Forbidden' },
    { code: 404, description: 'Not Found' },
    { code: 405, description: 'Method Not Allowed' },
    { code: 406, description: 'Not Acceptable' },
    { code: 407, description: 'Proxy Authentication Required' },
    { code: 408, description: 'Request Timeout' },
    { code: 409, description: 'Conflict' },
    { code: 410, description: 'Gone' },
    { code: 500, description: 'Internal Server Error' },
    { code: 501, description: 'Not Implemented' },
    { code: 502, description: 'Bad Gateway' },
    { code: 503, description: 'Service Unavailable' },
    { code: 504, description: 'Gateway Timeout' },
    { code: 505, description: 'HTTP Version Not Supported' }
  ];

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  getErrorDescription(errorCode: number, removeDetails?: boolean): string {
    if (errorCode > 3199 && errorCode < 3600) {
      const validCode = errorCode - 3000;
      const failureDescription = removeDetails
        ? null
        : this.failureCodes2.find(x => x.code === validCode)?.description;
      return failureDescription ? `HTTP ${validCode}:${failureDescription}` : `HTTP ${validCode}`;
    } else {
      const failureDescription = this.failureCodes1.find(x => x.code === errorCode)?.description;
      return failureDescription
        ? `${errorCode}:${failureDescription}`
        : `Unknown Error: ${errorCode}`;
    }
  }

  getDescription(errorCode: number): string {
    const failureDescription = this.failureCodes1.find(x => x.code === errorCode)?.description;
    return failureDescription ?? `Unknown Error: ${errorCode}`;
  }
}
